import studentAvatar from "../../assets/images/studentavatar.png";
import subjectBook from "../../assets/images/subjectbook.png";

const IMAGES = {
  studentAvatar,
  subjectBook,
};

export default IMAGES;
